export default __webpack_public_path__ + "static/media/charge.07d07082.svg";